(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.competition-draw-number.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/child-components/draw-card.competition-draw-number.js');
"use strict";


const DrawCardCompetitionDrawNumber = _ref => {
  let children = _ref.children,
    hasHiddenAria = _ref.hasHiddenAria;
  return React.createElement("div", {
    "aria-hidden": Boolean(hasHiddenAria),
    className: "pg_draw_card__competition_draw_nbr pg_draw_card_component"
  }, children);
};
setGlobal('svs.components.tipsen.drawCardComponents.DrawCardCompetitionDrawNumber', DrawCardCompetitionDrawNumber);

 })(window);